/** @jsx jsx */
import { jsx } from "theme-ui"

import { vwoService } from "@trueskin-web/services"

import menuSvg from "./menuIcon.svg"

export const menuIcon = vwoService.isThemeRebrandedEnabled()
  ? menuSvg
  : {
      path: (
        <path
          d="M4 16h24M4 8h16M4 24h16"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      ),
      viewBox: "0 0 32 32",
    }
